import React, { useEffect, useState } from 'react';
import { getStripePlans, pay } from '../../firebase/config';
import { useAuth } from '../../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faStar } from '@fortawesome/free-solid-svg-icons';
import './Premium.css';
import { useNavigate } from 'react-router-dom';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth, updateLastLogin } from '../../firebase/config';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'



const PLAN_NAMES = ['Gratis', 'Plan Explora', 'Plan Explora+', 'Plan Radar', 'Plan Radar+'];

const características = [
  {
    nombre: 'Número de alertas',
    info: 'Cantidad máxima de alertas que puedes configurar para recibir notificaciones de nuevos productos.'
  },
  {
    nombre: 'Sin anuncios',
    info: 'Elimina todos los anuncios para una experiencia de navegación más limpia y rápida.'
  },
  {
    nombre: 'Rastrear Productos',
    info: 'Haz seguimiento a productos específicos y recibe notificacoines cuando cambien de precio.'
  },
  {
    nombre: 'Alertas con IA',
    info: 'Crea alertas con IA que te avisan solo cuando aparecen productos más baratos de lo normal, usando nuestro modelo para filtrar por euros o porcentaje de ahorro.'
  }
];

const beneficios = {
  'Gratis': ['1', <FontAwesomeIcon icon={faTimes} />, <FontAwesomeIcon icon={faTimes} />, <FontAwesomeIcon icon={faTimes} />],
  'Plan Explora': ['25', <FontAwesomeIcon icon={faCheck} />, '25', <FontAwesomeIcon icon={faTimes} />],
  'Plan Explora+': ['50', <FontAwesomeIcon icon={faCheck} />, '50', <FontAwesomeIcon icon={faCheck} />],
  'Plan Radar': ['100', <FontAwesomeIcon icon={faCheck} />, '100', <FontAwesomeIcon icon={faCheck} />],
  'Plan Radar+': ['200', <FontAwesomeIcon icon={faCheck} />,'200', <FontAwesomeIcon icon={faCheck} />],
};

export const Premium = () => {

  const [planesData, setPlanesData] = useState({});
  const [loading, setLoading] = useState(false);
  const { user, premium } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user && premium) {
      navigate('/usuario', { replace: true });
    }
  }, [user, premium, navigate]);

      async function handleGoogleAuth() {
          const googleProvider = new GoogleAuthProvider();
          try {
              const res = await signInWithPopup(auth, googleProvider);
              const user = res.user;
              await updateLastLogin(user.uid);
          } catch (err) {
              console.error(err);
              setError('Ocurrió un error al iniciar sesión con Google.');
          }
      }

  useEffect(() => {
    async function fetchData() {
      const data = await getStripePlans();
      setPlanesData(data);
    }
    fetchData();
  }, []);

  const handleSubscribe = async (priceId) => {
    setLoading(true);
    try {
      await pay(user, priceId);
    } catch (e) {
      console.error(e);
      alert("Error durante el proceso de suscripción.");
    } finally {
      setLoading(false);
    }
  };

  const renderPrice = (planName, type) => {
    if (planName === 'Gratis') return '0€';
    const price = planesData[planName]?.prices?.[type];
    return price ? `${(price.unit_amount / 100).toFixed(2)}€` : '...';
  };

  const renderButton = (planName, type) => {
    if (planName === 'Gratis') return null;
    const price = planesData[planName]?.prices?.[type];
    return (
      <button
        disabled={loading || !price}
        onClick={() => handleSubscribe(price.priceId)}
      >
        {type === 'monthly' ? 'Mensual' : 'Anual'} 
        {planName === 'Plan Explora+' && <FontAwesomeIcon icon={faStar} style={{ marginLeft: '5px' }} />}
      </button>
    );
  };

  // Función para determinar si una columna es la popular (Plan Explora+)
  const isPopularColumn = (plan) => plan === 'Plan Explora+';


  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    });
  
    const secciones = document.querySelectorAll('.funcionalidad');
    secciones.forEach((el) => observer.observe(el));
  
    return () => observer.disconnect();
  }, []);
  

  return (
    <div className="tabla-planes">
      <h1>Planes Premium</h1>
      <p className="descripcion-premium-recordatorio">
        Te recordamos  que a diferencia de otros sistemas de alertas que requieren conectar tus cuentas o automatizan compras,  
        eRastro está diseñado para ser <strong>100 % seguro</strong> ya que  no interactuamos con tus cuentas de Vinted, Wallapop o eBay. Puedes usarlo con total tranquilidad, tus cuentas no serán baneadas.
      </p>
      <p className="descripcion-premium">
        Con el plan gratis puedes crear una alerta y explorar oportunidades en nuestro directorio, pero si quieres tener acceso a funcionalidades premium, mira nuestros planes de pago y escoge el que más se te adapte.
      </p>
      <div className="vista-escritorio">
        <table>
          <thead>
            <tr>
              <th>Características</th>
              {PLAN_NAMES.map((plan) => (
                <th key={plan} className={isPopularColumn(plan) ? 'popular-column' : ''}>
                  {plan}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {características.map((carac, idx) => (
              <tr key={idx}>
              <td>
                {carac.nombre}
                <span className="info-container">
                  <span className="info-icon">
                    <FontAwesomeIcon icon={faCircleInfo} />
                  </span>
                  <div className="info-tooltip">{carac.info}</div>
                </span>
              </td>
              {PLAN_NAMES.map((plan) => (
                  <td key={plan} className={isPopularColumn(plan) ? 'popular-column' : ''}>
                    {beneficios[plan][idx]}
                  </td>
                ))}
              </tr>
            ))}
            <tr>
              <td>Precio mensual</td>
              {PLAN_NAMES.map((plan) => (
                <td key={plan} className={isPopularColumn(plan) ? 'popular-column' : ''}>
                  {renderPrice(plan, 'monthly')}
                </td>
              ))}
            </tr>
            {/*<tr>
              <td>Precio anual</td>
              {PLAN_NAMES.map((plan) => (
                <td key={plan} className={isPopularColumn(plan) ? 'popular-column' : ''}>
                  {renderPrice(plan, 'annual')}
                </td>
              ))}
            </tr>*/}
            {user && (
              <tr>
                <td></td>
                {PLAN_NAMES.map((plan) => (
                  <td key={plan} className={isPopularColumn(plan) ? 'popular-column' : ''}>
                    {renderButton(plan, 'monthly')}
                    {/*renderButton(plan, 'annual')*/}
                  </td>
                ))}
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {!user && (
        <>
          <p className="descripcion-premium">Inicia sesión o regístrate para contratar un plan</p>
          <div className='botones-login'>
            <button className='boton-login' onClick={handleGoogleAuth}>
              Iniciar Sesión / Registrarse con Google
            </button>
          </div>
        </>
      )}
      {/* Nueva sección de explicación de beneficios */}
      <div className="explicacion-premium">
        <h2 className="titulo-premium">¿Por qué hacerte Premium?</h2>

        {/* Alertas inteligentes */}
        <div className="funcionalidad con-imagen reverse">
          <div className="imagen">
            <img src="/imgs/captura-alertas.png" alt="Configuración de alertas premium" />
          </div>
          <div className="contenido">
            <h3>Alertas Inteligentes</h3>
            <p>
              Con los planes <strong>Premium</strong> puedes crear <strong>alertas inteligentes</strong>. 
              Nuestro sistema empezará a rastrear por ti múltiples webs de ropa de segunda mano y te avisará cuando encontremos lo que buscas, 
              no se te escapará ninguna oportunidad.
            </p>
          </div>
        </div>

        {/* IA avanzada */}
        <div className="funcionalidad con-imagen">
          <div className="imagen">
            <img src="/imgs/captura-modelo-IA.png" alt="Resultados con IA para encontrar gangas" />
          </div>
          <div className="contenido">
            <h3>IA para encontrar gangas</h3>
            <p>
              Nuestro modelo de inteligencia artificial analiza miles de productos para encontrar las mejores gangas. Podrás 
              usarlo para configurar alertas avanzadas. Verás qué productos están por debajo del precio medio
              del mercado de segunda mano y cuánto te ahorras en euros y en porcentaje.
            </p>
          </div>
        </div>

        {/* Seguimiento de precios */}
        <div className="funcionalidad con-imagen reverse">
          <div className="imagen">
            <img src="/imgs/captura-productos-fav.png" alt="Vista del seguimiento de productos y precios" />
          </div>
          <div className="contenido">
            <h3>Rastreador de precios</h3>
            <p>
              Guarda los productos que te interesan y nuestro sistema rastreará los cambios de precio. Te notificaremos cuando bajen.
              Ideal para comprar en el momento justo y no pagar de más.
            </p>
          </div>
        </div>

        {/* Web sin anuncios */}
        <div className="funcionalidad sin-imagen">
          <div className="contenido">
            <h3>Navegación sin anuncios</h3>
            <p>
              Disfruta de una experiencia libre de distracciones. Elimina todos los anuncios y navega de forma limpia y rápida,
              sin interrupciones ni banners molestos.
            </p>
          </div>
        </div>
      </div>
      <h2 className="titulo-premium">Comparativa de Planes Premium</h2>
      <p className="descripcion-premium">Elige el plan que más se adapte a tus necesidades</p>
      <div className="vista-escritorio">
        <table>
          <thead>
            <tr>
              <th>Característica</th>
              {PLAN_NAMES.map((plan) => (
                <th key={plan} className={isPopularColumn(plan) ? 'popular-column' : ''}>
                  {plan}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {características.map((carac, idx) => (
              <tr key={idx}>
                <td>
                  {carac.nombre}
                  <span className="info-container">
                    <span className="info-icon">
                      <FontAwesomeIcon icon={faCircleInfo} />
                    </span>
                    <div className="info-tooltip">{carac.info}</div>
                  </span>
                </td>
                {PLAN_NAMES.map((plan) => (
                  <td key={plan} className={isPopularColumn(plan) ? 'popular-column' : ''}>
                    {beneficios[plan][idx]}
                  </td>
                ))}
              </tr>
            ))}
            <tr>
              <td>Precio mensual</td>
              {PLAN_NAMES.map((plan) => (
                <td key={plan} className={isPopularColumn(plan) ? 'popular-column' : ''}>
                  {renderPrice(plan, 'monthly')}
                </td>
              ))}
            </tr>
            {/*<tr>
              <td>Precio anual</td>
              {PLAN_NAMES.map((plan) => (
                <td key={plan} className={isPopularColumn(plan) ? 'popular-column' : ''}>
                  {renderPrice(plan, 'annual')}
                </td>
              ))}
            </tr>*/}
            {user && (
              <tr>
                <td></td>
                {PLAN_NAMES.map((plan) => (
                  <td key={plan} className={isPopularColumn(plan) ? 'popular-column' : ''}>
                    {renderButton(plan, 'monthly')}
                    {/*renderButton(plan, 'annual')*/}
                  </td>
                ))}
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="vista-movil">
        {PLAN_NAMES.map((plan, idx) => (
          <div className="card-plan" key={plan}>
            <h2>{plan}</h2>
            <ul>
              {características.map((carac, i) => (
                <li key={i}>
                  <strong>{carac.nombre}</strong>: {beneficios[plan][i]}
                </li>
              ))}
              <li><strong>Precio mensual:</strong> {renderPrice(plan, 'monthly')}</li>
              <li><strong>Precio anual:</strong> {renderPrice(plan, 'annual')}</li>
            </ul>
            {user && (
              <div className="botones-plan">
                {renderButton(plan, 'monthly')}
                {renderButton(plan, 'annual')}
              </div>
            )}
          </div>
        ))}
      </div>
      {!user && (
        <>
          <p className="descripcion-premium">Inicia sesión o regístrate para contratar un plan</p>
          <div className='botones-login'>
            <button className='boton-login' onClick={handleGoogleAuth}>
              Iniciar Sesión / Registrarse con Google
            </button>
          </div>
        </>
      )}
    </div>
  );
};